/**
 * 产品目录与自有后端路径对齐 IdoingProductController（OpenGate 对外 API，含 CORS）
 */

import { getApiBaseUrl } from '../utils/apiBaseUrl'

/**
 * 后端 Base（OpenGate Key 调 /idoing_*；上游 Key 只在服务端）
 * 开发：留空，走 vue.config.js 代理
 * 生产：默认 https://open.pluskeji.cn
 */
export const API_BASE = getApiBaseUrl()

export const AUTH_HEADER_DESC =
  'OpenGate 密钥：Authorization: og_live_xxx + 请求头 X-Api-Secret: sk_xxx（账号积分余额须 > 0；支持浏览器跨域）'

/** 侧栏 / 顶部分类 */
export const productTypes = [
  { id: 'all', name: '所有产品', path: '/type/all' },
  // { id: 'platform', name: '平台探测', path: '/type/platform' },
  { id: 'doubao', name: '豆包', path: '/type/doubao' },
  { id: 'banana', name: '香蕉生图', path: '/type/banana' },
  { id: 'gpt-image', name: 'GPT-IMAGE', path: '/type/gpt-image' },
  { id: 'suno', name: 'SUNO音乐', path: '/type/suno' },
  { id: 'video', name: 'SORA/VEO/GROK视频', path: '/type/video' },
  { id: 'kling-video', name: 'KLING视频', path: '/type/kling-video' },
  { id: 'kling-image', name: 'KLING图像', path: '/type/kling-image' },
  { id: 'midjourney', name: 'MIDJOURNEY图片', path: '/type/midjourney' }
]

const authParam = {
  name: 'Authorization',
  in: 'header',
  required: true,
  type: 'string',
  desc: AUTH_HEADER_DESC
}

const secretParam = {
  name: 'X-Api-Secret',
  in: 'header',
  required: true,
  type: 'string',
  desc: '创建密钥时下发的 Secret（sk_...）'
}

/** @type {Array<object>} */
export const products = [
  // {
  //   id: 'idoing-ping',
  //   typeId: 'platform',
  //   title: '健康检查 / 探测',
  //   desc: '无需鉴权；探测 OpenGate 是否可达，并返回鉴权头说明',
  //   paid: false,
  //   priceLabel: '免费',
  //   limitLabel: '无',
  //   method: 'GET',
  //   path: '/idoing_ping',
  //   controller: 'IdoingProductController@idoing_ping',
  //   params: [],
  //   sampleBody: null,
  //   sampleResponse: {
  //     code: 0,
  //     data: {
  //       ok: true,
  //       name: 'OpenGate API',
  //       auth: { type: 'api_key', headers: ['Authorization: og_live_xxx', 'X-Api-Secret: sk_xxx'] }
  //     }
  //   }
  // },
  {
    id: 'idoing-task-show',
    typeId: 'kling-video',
    title: '通用任务查询',
    desc: 'GET /idoing_task/{task_id}?kind=image|video|auto（可灵等异步任务）',
    paid: false,
    priceLabel: '不另计费',
    limitLabel: '与创建接口共用配额',
    method: 'GET',
    path: '/idoing_task/{task_id}',
    pathParams: ['task_id'],
    controller: 'IdoingProductController@idoing_task_show',
    params: [
      authParam,
      secretParam,
      { name: 'task_id', in: 'path', required: true, type: 'string', desc: '上游 task_id' },
      { name: 'kind', in: 'query', required: false, type: 'string', desc: 'image | video | auto（默认 auto）' }
    ],
    sampleBody: null,
    samplePathParams: { task_id: 'task_xxx' },
    sampleResponse: {
      id: 'task_xxx',
      task_id: 'task_xxx',
      status: 'succeeded',
      provider: 'idoing',
      kind: 'video',
      video_url: 'https://cdn.example.com/v.mp4'
    }
  },
  {
    id: 'suno-relink',
    typeId: 'suno',
    title: '付费重新生成suno链接',
    desc: '旧 Suno 链接失效时通过本接口救回',
    paid: true,
    priceLabel: '0.01元/次',
    limitLabel: '注册即送100次',
    bonus: '注册即送100次',
    method: 'POST',
    path: '/idoing_suno_relink',
    controller: 'IdoingProductController@idoing_suno_relink',
    params: [
      authParam,
      secretParam,
      { name: 'task_id', in: 'body', required: false, type: 'string', desc: '原任务 ID' }
    ],
    sampleBody: { task_id: 'suno_xxx' },
    sampleResponse: {
      provider: 'idoing',
      status: 'ok',
      model: 'suno-relink',
      raw: {}
    }
  },
  {
    id: 'gpt-image',
    typeId: 'gpt-image',
    title: '付费gpt-image',
    desc: '异步创建任务，再用 GET /idoing_gpt_image/{task_id} 轮询',
    paid: true,
    priceLabel: '0.06元/次',
    limitLabel: '每日限制请求1000000次',
    method: 'POST',
    path: '/idoing_gpt_image',
    controller: 'IdoingProductController@idoing_gpt_image',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: true, type: 'string', desc: '提示词，最长 5000' },
      {
        name: 'model',
        in: 'body',
        required: false,
        type: 'string',
        desc: 'gpt-image-2 / gpt-image-2.5-flare / gpt-image-2.5-sunburst / nano-banana'
      },
      { name: 'size', in: 'body', required: false, type: 'string', desc: '如 1024x1024 或 1:1 / auto' },
      { name: 'quality', in: 'body', required: false, type: 'string', desc: '默认 high' },
      { name: 'image', in: 'body', required: false, type: 'string|array', desc: '参考图公网 URL' },
      { name: 'images', in: 'body', required: false, type: 'array', desc: '多张参考图 URL' }
    ],
    sampleBody: {
      prompt: '一只赛博朋克风格的猫',
      model: 'gpt-image-2',
      size: '1024x1024'
    },
    sampleResponse: {
      id: 'task_xxx',
      task_id: 'task_xxx',
      status: 'submitted',
      model: 'gpt-image-2',
      provider: 'idoing'
    },
    pollEndpointId: 'gpt-image-show'
  },
  {
    id: 'gpt-image-show',
    typeId: 'gpt-image',
    title: 'gpt-image 任务查询',
    desc: '轮询异步出图结果',
    paid: true,
    priceLabel: '不另计费',
    limitLabel: '与创建接口共用配额',
    method: 'GET',
    path: '/idoing_gpt_image/{task_id}',
    pathParams: ['task_id'],
    controller: 'IdoingProductController@idoing_gpt_image_show',
    params: [
      authParam,
      secretParam,
      { name: 'task_id', in: 'path', required: true, type: 'string', desc: '创建接口返回的 task_id' }
    ],
    sampleBody: null,
    samplePathParams: { task_id: 'task_xxx' },
    sampleResponse: {
      id: 'task_xxx',
      task_id: 'task_xxx',
      status: 'succeeded',
      provider: 'idoing',
      url: 'https://cdn.example.com/a.png',
      urls: [{ url: 'https://cdn.example.com/a.png', upstream_url: 'https://...' }]
    },
    createEndpointId: 'gpt-image'
  },
  {
    id: 'seedance-2',
    typeId: 'doubao',
    title: '付费seedance2.0',
    desc: '豆包 Seedance 视频，按秒扣积分；创建后用 GET /idoing_seedance/{task_id} 查询',
    paid: true,
    priceLabel: '1元/秒',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_seedance',
    controller: 'IdoingProductController@idoing_seedance',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: true, type: 'string', desc: '视频描述' },
      {
        name: 'model',
        in: 'body',
        required: false,
        type: 'string',
        desc: '默认 doubao-seedance-2-0-260128'
      },
      { name: 'duration', in: 'body', required: false, type: 'number', desc: '秒数 1–30，默认 5' },
      { name: 'ratio', in: 'body', required: false, type: 'string', desc: '画幅比例' },
      { name: 'images', in: 'body', required: false, type: 'array', desc: '参考图公网 URL' }
    ],
    sampleBody: {
      prompt: '城市夜景航拍',
      model: 'doubao-seedance-2-0-260128',
      duration: 5,
      ratio: '16:9'
    },
    sampleResponse: {
      id: 'task_xxx',
      task_id: 'task_xxx',
      status: 'submitted',
      model: 'doubao-seedance-2-0-260128',
      provider: 'idoing'
    },
    pollEndpointId: 'seedance-show'
  },
  {
    id: 'seedance-show',
    typeId: 'doubao',
    title: 'seedance 任务查询',
    desc: '轮询 Seedance 视频任务',
    paid: true,
    priceLabel: '不另计费',
    limitLabel: '与创建接口共用配额',
    method: 'GET',
    path: '/idoing_seedance/{task_id}',
    pathParams: ['task_id'],
    controller: 'IdoingProductController@idoing_seedance_show',
    params: [
      authParam,
      secretParam,
      { name: 'task_id', in: 'path', required: true, type: 'string', desc: '创建接口返回的 task_id' }
    ],
    sampleBody: null,
    samplePathParams: { task_id: 'task_xxx' },
    sampleResponse: {
      id: 'task_xxx',
      status: 'succeeded',
      provider: 'idoing',
      video_url: 'https://cdn.example.com/v.mp4'
    },
    createEndpointId: 'seedance-2'
  },
  {
    id: 'kling-motion',
    typeId: 'kling-video',
    title: '付费可灵动作控制',
    desc: '可灵动作控制（按秒扣费）',
    paid: true,
    priceLabel: '按秒计费',
    limitLabel: '每日限制请求100000次',
    method: 'POST',
    path: '/idoing_kling_motion',
    controller: 'IdoingProductController@idoing_kling_motion',
    params: [
      authParam,
      secretParam,
      { name: 'duration', in: 'body', required: false, type: 'number', desc: '时长秒，默认 5' },
      { name: 'image', in: 'body', required: false, type: 'string', desc: '参考图公网 URL' },
      { name: 'prompt', in: 'body', required: false, type: 'string', desc: '可选提示' }
    ],
    sampleBody: {
      duration: 5,
      image: 'https://cdn.example.com/ref.png',
      prompt: '跟随动作'
    },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-motion-control',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'suno-midi',
    typeId: 'suno',
    title: '付费suno生成midi',
    desc: 'Suno 生成 MIDI',
    paid: true,
    priceLabel: '0.005元/次',
    limitLabel: '注册即送100次',
    bonus: '注册即送100次',
    method: 'POST',
    path: '/idoing_suno_midi',
    controller: 'IdoingProductController@idoing_suno_midi',
    params: [
      authParam,
      secretParam,
      { name: 'audio_url', in: 'body', required: false, type: 'string', desc: '音频地址（按上游文档）' }
    ],
    sampleBody: { audio_url: 'https://cdn.example.com/a.mp3' },
    sampleResponse: {
      provider: 'idoing',
      status: 'ok',
      model: 'suno-midi',
      raw: {}
    }
  },
  {
    id: 'kling-omni',
    typeId: 'kling-video',
    title: '付费可灵omni',
    desc: '可灵 Omni 多模态视频，按秒计费',
    paid: true,
    priceLabel: '按秒计费',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_kling_omni',
    controller: 'IdoingProductController@idoing_kling_omni',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: false, type: 'string', desc: '提示词' },
      { name: 'duration', in: 'body', required: false, type: 'number', desc: '秒数，默认 5' },
      { name: 'model', in: 'body', required: false, type: 'string', desc: '扣费 model_id，默认 kling-omni' }
    ],
    sampleBody: { prompt: '角色一致性示范镜头', duration: 5 },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-omni',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'kling-digital-human',
    typeId: 'kling-video',
    title: '免费可灵数字人',
    desc: '可灵数字人 image2video',
    paid: false,
    priceLabel: '免费',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_kling_digital_human',
    controller: 'IdoingProductController@idoing_kling_digital_human',
    params: [
      authParam,
      secretParam,
      { name: 'image', in: 'body', required: false, type: 'string', desc: '人物图公网 URL' },
      { name: 'audio_url', in: 'body', required: false, type: 'string', desc: '驱动音频（按上游文档）' }
    ],
    sampleBody: {
      image: 'https://cdn.example.com/face.png',
      audio_url: 'https://cdn.example.com/a.mp3'
    },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-digital-human',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'sora-veo-grok',
    typeId: 'video',
    title: '付费sora/veo/grok AI生视频',
    desc: 'Sora / Veo / Grok（主站 FastMovie 转发；权威实现 IdoingProductController）',
    paid: true,
    priceLabel: '0.2元/次',
    limitLabel: '每日限制请求1000000次',
    method: 'POST',
    path: '/idoing_video',
    controller: 'FastMovieController@idoing_video → IdoingProductController',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: true, type: 'string', desc: '提示词' },
      { name: 'model', in: 'body', required: true, type: 'string', desc: '上游模型 ID（sora/veo/grok 系列）' },
      { name: 'duration', in: 'body', required: false, type: 'number', desc: '时长秒' },
      { name: 'ratio', in: 'body', required: false, type: 'string', desc: '画幅' },
      { name: 'resolution', in: 'body', required: false, type: 'string', desc: '720p / 1080p' },
      { name: 'images', in: 'body', required: false, type: 'array', desc: '参考图 URL' }
    ],
    sampleBody: {
      model: 'grok-video',
      prompt: '海边日落延时',
      duration: 5,
      ratio: '16:9',
      resolution: '720p'
    },
    sampleResponse: {
      id: 'task_xxx',
      task_id: 'task_xxx',
      status: 'submitted',
      model: 'grok-video',
      provider: 'idoing'
    },
    pollEndpointId: 'sora-veo-grok-show'
  },
  {
    id: 'sora-veo-grok-show',
    typeId: 'video',
    title: 'sora/veo/grok 任务查询',
    desc: 'GET /idoing_video/{task_id}',
    paid: true,
    priceLabel: '不另计费',
    limitLabel: '与创建接口共用配额',
    method: 'GET',
    path: '/idoing_video/{task_id}',
    pathParams: ['task_id'],
    controller: 'FastMovieController@idoing_video_show → IdoingProductController',
    params: [
      authParam,
      secretParam,
      { name: 'task_id', in: 'path', required: true, type: 'string', desc: '创建接口返回的 task_id' }
    ],
    sampleBody: null,
    samplePathParams: { task_id: 'task_xxx' },
    sampleResponse: {
      id: 'task_xxx',
      status: 'succeeded',
      provider: 'idoing',
      video_url: 'https://cdn.example.com/v.mp4'
    },
    createEndpointId: 'sora-veo-grok'
  },
  {
    id: 'kling-outpaint',
    typeId: 'kling-image',
    title: '付费可灵扩图',
    desc: '可灵图像扩图',
    paid: true,
    priceLabel: '0.16元/次',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_kling_outpaint',
    controller: 'IdoingProductController@idoing_kling_outpaint',
    params: [
      authParam,
      secretParam,
      { name: 'image', in: 'body', required: false, type: 'string', desc: '原图公网 URL' }
    ],
    sampleBody: { image: 'https://cdn.example.com/a.png' },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-outpaint',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'kling-multi-ref',
    typeId: 'kling-image',
    title: '付费可灵多图参考生图',
    desc: '多图参考生成',
    paid: true,
    priceLabel: '0.32元/次',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_kling_multi_image',
    controller: 'IdoingProductController@idoing_kling_multi_image',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: false, type: 'string', desc: '提示词' },
      { name: 'images', in: 'body', required: false, type: 'array', desc: '参考图 URL 列表' }
    ],
    sampleBody: {
      images: ['https://cdn.example.com/a.png', 'https://cdn.example.com/b.png'],
      prompt: '融合风格肖像'
    },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-multi-image',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'kling-image-gen',
    typeId: 'kling-image',
    title: '付费可灵图像生成',
    desc: '价格按模型与是否带图综合定价',
    paid: true,
    priceLabel: '0.02元/次起',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_kling_image',
    controller: 'IdoingProductController@idoing_kling_image',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: true, type: 'string', desc: '提示词' },
      { name: 'image', in: 'body', required: false, type: 'string', desc: '可选参考图 URL' },
      { name: 'model', in: 'body', required: false, type: 'string', desc: '扣费 model_id' }
    ],
    sampleBody: { prompt: '水彩风景' },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-image',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'kling-mm-edit',
    typeId: 'kling-video',
    title: '免费可灵多模态视频编辑',
    desc: '多模态视频编辑',
    paid: false,
    priceLabel: '免费',
    limitLabel: '每日限制请求10000次',
    method: 'POST',
    path: '/idoing_kling_mm_edit',
    controller: 'IdoingProductController@idoing_kling_mm_edit',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: false, type: 'string', desc: '编辑说明' },
      { name: 'video_url', in: 'body', required: false, type: 'string', desc: '原视频 URL' }
    ],
    sampleBody: { video_url: 'https://cdn.example.com/v.mp4', prompt: '替换天空' },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      model: 'kling-mm-edit',
      task_id: 'task_xxx'
    }
  },
  {
    id: 'banana-image',
    typeId: 'banana',
    title: '付费香蕉生图',
    desc: '走 /idoing_gpt_image，model 传 nano-banana',
    paid: true,
    priceLabel: '按模型计费',
    limitLabel: '每日限制请求100000次',
    method: 'POST',
    path: '/idoing_gpt_image',
    controller: 'IdoingProductController@idoing_gpt_image',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: true, type: 'string', desc: '提示词' },
      { name: 'model', in: 'body', required: true, type: 'string', desc: '固定 nano-banana 或 nano-banana-2' },
      { name: 'size', in: 'body', required: false, type: 'string', desc: '尺寸' }
    ],
    sampleBody: {
      prompt: '产品白底精修图',
      model: 'nano-banana',
      size: '1024x1024'
    },
    sampleResponse: {
      id: 'task_xxx',
      task_id: 'task_xxx',
      status: 'submitted',
      model: 'nano-banana',
      provider: 'idoing'
    },
    pollEndpointId: 'gpt-image-show'
  },
  {
    id: 'midjourney',
    typeId: 'midjourney',
    title: '付费 Midjourney 图片',
    desc: 'Midjourney 快速生成',
    paid: true,
    priceLabel: '按次计费',
    limitLabel: '每日限制请求50000次',
    method: 'POST',
    path: '/idoing_mj',
    controller: 'IdoingProductController@idoing_mj',
    params: [
      authParam,
      secretParam,
      { name: 'prompt', in: 'body', required: true, type: 'string', desc: 'action=generate 时必填' },
      { name: 'action', in: 'body', required: false, type: 'string', desc: '默认 generate；后续 upsample 等' },
      { name: 'image_id', in: 'body', required: false, type: 'string', desc: '后续操作时的图像 ID' },
      { name: 'callback_url', in: 'body', required: false, type: 'string', desc: 'Webhook' }
    ],
    sampleBody: { action: 'generate', prompt: 'epic fantasy castle --v 6' },
    sampleResponse: {
      provider: 'idoing',
      status: 'submitted',
      raw: {}
    }
  }
  // {
  //   id: 'idoing-products',
  //   typeId: 'platform',
  //   title: '已封装产品目录',
  //   desc: 'GET 公开目录（无需鉴权）；带 Key+Secret 时附带积分余额调试',
  //   paid: false,
  //   priceLabel: '免费',
  //   limitLabel: '无',
  //   method: 'GET',
  //   path: '/idoing_products',
  //   controller: 'IdoingProductController@idoing_products',
  //   params: [
  //     {
  //       name: 'Authorization',
  //       in: 'header',
  //       required: false,
  //       type: 'string',
  //       desc: '可选；og_live_xxx 时返回 score_balance / score_debug'
  //     },
  //     {
  //       name: 'X-Api-Secret',
  //       in: 'header',
  //       required: false,
  //       type: 'string',
  //       desc: '可选；与 Authorization 成对'
  //     }
  //   ],
  //   sampleBody: null,
  //   sampleResponse: {
  //     code: 0,
  //     data: {
  //       name: 'OpenGate API',
  //       cors: true,
  //       list: [{ id: 'gpt-image', method: 'POST', path: '/idoing_gpt_image', auth: true }]
  //     }
  //   }
  // }
]

export function resolveRequestUrl(pathTemplate, pathParams = {}) {
  let path = pathTemplate || ''
  Object.keys(pathParams || {}).forEach(k => {
    const v = encodeURIComponent(String(pathParams[k] ?? ''))
    path = path.replace('{' + k + '}', v).replace(':' + k, v)
  })
  if (!path.startsWith('/')) path = '/' + path
  return API_BASE ? API_BASE + path : path
}

export function getTypeById(typeId) {
  return productTypes.find(t => t.id === typeId) || productTypes[0]
}

export function listProductsByType(typeId) {
  if (!typeId || typeId === 'all') return products.slice()
  return products.filter(p => p.typeId === typeId)
}

export function getProductById(id) {
  return products.find(p => p.id === id) || null
}

function toEndpointView(p) {
  return {
    id: p.id,
    method: p.method,
    path: p.path,
    pathParams: p.pathParams || [],
    samplePathParams: p.samplePathParams || null,
    summary: p.title,
    desc: p.desc || '',
    sampleBody: p.sampleBody,
    sampleResponse: p.sampleResponse,
    params: p.params,
    groupId: p.typeId,
    groupName: getTypeById(p.typeId).name,
    controller: p.controller,
    pollEndpointId: p.pollEndpointId || null,
    createEndpointId: p.createEndpointId || null
  }
}

export function findEndpoint(id) {
  const p = getProductById(id)
  if (!p) return null
  const group = getTypeById(p.typeId)
  return {
    group: { id: group.id, name: group.name },
    endpoint: toEndpointView(p)
  }
}

export function allEndpoints() {
  return products.map(toEndpointView)
}

export const apiGroups = productTypes
  .filter(t => t.id !== 'all')
  .map(t => ({
    id: t.id,
    name: t.name,
    description: t.name,
    endpoints: listProductsByType(t.id).map(p => toEndpointView(p))
  }))
  .filter(g => g.endpoints.length > 0)
